import { useEffect } from "react";
import { useAsyncData } from "./useAsyncData";

export const usePollingData = (loader, options = {}) => {
    const { intervalMs = 30000, enabled = true, ...asyncOptions } = options;
    const state = useAsyncData(loader, { ...asyncOptions, immediate: enabled && asyncOptions.immediate !== false });

    useEffect(() => {
        if (!enabled || !intervalMs) return undefined;
        const interval = setInterval(() => {
            state.reload().catch(() => {});
        }, intervalMs);

        return () => clearInterval(interval);
    }, [enabled, intervalMs, state.reload]);

    return state;
};
